//com.southvanmed/src/components/Payment/payment.js
import React, { Fragment } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { connect } from 'react-redux';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js';
import { Button, Container } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// components

import config from '../../config';
import { setAlert } from '../../services/sweetAlert';
import { setToLoading, setToLoaded } from '../../actions/loader';
import { sickNoteService } from '../../services/sicknote.service';
import { history } from '../../_helpers';
import CommonPageHeader from '../CommonPageHeader/CommonPageHeader';
import { useFeeConfig } from '../../services/config.service';
import { trackCBCEvent } from '../../Analytics';
// const stripePromise = loadStripe(config.stripePublicKey);
// import ReactDOM from "react-dom";

// import { setAlert } from '../../actions/alert';

// import { setAlert } from '../../services/sweetAlert';

// import { setToLoading, setToLoaded } from '../../actions/loader';
// import { sickNoteService } from '../../services/sicknote.service';

// import { history } from '../../_helpers';
// import CommonPageHeader from '../CommonPageHeader/CommonPageHeader';

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      //     iconColor: "#c4f0ff",
      //     color: "#fff",
      //     fontWeight: 500,
      //     fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: '16px'
      //     fontSmoothing: "antialiased",
      //     ":-webkit-autofill": {
      //       color: "#fce883"
      //     },
      //     "::placeholder": {
      //       color: "#87bbfd"
      //     }
      //   },
      //   invalid: {
      //     iconColor: "#ffc7ee",
      //     color: "#ffc7ee"
    }
  }
};

const mapDispatchToProps = {
  setToLoaded,
  setToLoading
};
const mapStateToProps = state => ({
  sickNote: state.sickNote,
  user: state.auth.user
});
class CheckoutForm extends React.Component {
  constructor() {
    super();
    this.state = {
      isDialog: false,
      isSubmitting: false
    };
  }
  handleServerResponse = async response => {
    console.log('🚀 Payment.js - handleServerResponse called');
    console.log('🚀 Full server response:', response);

    if (response.data.success) {
      this.props.setToLoaded();
      this.setState({ isSubmitting: false });

      const { sickNote } = this.props;
      const formType = sickNote.data?.formType || 'sick-note';

      // 🔥 CBC TRACKING: Payment success (now via GTM like other events)
      try {
        const cbcAttribution = localStorage.getItem('cbc_campaign_attribution') || sessionStorage.getItem('cbc_campaign_attribution');
        if (cbcAttribution) {
          trackCBCEvent('cbc_payment_success', {
            form_type: formType,
            form_category: formType === 'school-work-form' ? 'school_work' : 'sick_note',
            funnel_step: 'payment_success',
            is_complex_form: formType === 'school-work-form',
            payment_success: true
          });
          console.log(`🔥 CBC PAYMENT SUCCESS: ${formType} (via GTM)`);
        }
      } catch (error) {
        console.error('Error tracking CBC payment success:', error);
      }
      const formId = sickNote.data?.formId || response.data.extras?.formId;
      const accessToken = sickNote.data?.accessToken || response.data.extras?.accessToken;

      // console.log("Form type in handleServerResponse:", formType);

      // Store form ID in localStorage for recovery after payment
      if (formType === 'school-work-form' && formId) {
        localStorage.setItem('schoolWorkFormId', formId);
      }

      // For school-work forms, redirect to the file upload page instead of calling Oscar API directly
      if (formType === 'school-work-form' && formId) {
        // console.log("Redirecting to file upload page for form:", formId);

        // If we have an accessToken, use the token-based URL
        if (accessToken) {
          // console.log("Redirecting to token-based upload page:", accessToken);
          history.push(`/school-work-form/upload-token/${encodeURIComponent(accessToken)}`);
        } else {
          // Fallback to ID-based URL
          // console.log("Redirecting to ID-based upload page for form:", formId);
          history.push(`/school-work-form/upload/${formId}`);
        }
        return;
      }

      // Original sick note flow - unchanged
      const successPath = '/sick-note/payment/success';
      // console.log("Redirecting to success path:", successPath);
      history.push(successPath);
      return;
    }

    if (response.data.requires_action) {
      console.log('🔍 3DS Debug - Full response structure:', response.data);
      console.log('🔍 3DS Debug - next_action:', response.data.next_action);

      // NEW: Handle redirect-based 3DS for 2025-07-30.basil API
      if (response.data.next_action && response.data.next_action.type === 'redirect_to_url') {
        // Redirect to 3DS authentication page
        console.log('🔄 Redirecting to 3DS authentication page:', response.data.next_action.redirect_to_url.url);
        window.location.href = response.data.next_action.redirect_to_url.url;
        return;
      } else {
        // FALLBACK: Use old iframe method for backwards compatibility
        let intentConfirm = await this.props.stripe.handleCardAction(response.data.payment_intent_client_secret);
        if (!intentConfirm || !intentConfirm.paymentIntent) {
          setAlert({
            message: 'Card validation error',
            icon: 'error'
          });
          return;
        }

        try {
          response = await sickNoteService.charge({
            payment_intent_id: intentConfirm.paymentIntent.id,
            sickNote: this.props.sickNote
          });

          return await this.handleServerResponse(response);
        } catch (error) {
          this.props.setToLoaded();
          this.setState({ isSubmitting: false });
          setAlert({
            message: error.message || 'Payment processing error',
            icon: 'error'
          });
        }
      }
    }

    this.props.setToLoaded();
    this.setState({ isSubmitting: false });
    console.log('Error response:', response);
    setAlert({
      message: response.data.error || 'Card Failed',
      icon: 'error'
    });
    return;
  };
  handleSubmit = async event => {
    console.log('🚀 Payment.js - handleSubmit called');
    event.preventDefault();

    // Prevent multiple submissions
    if (this.state.isSubmitting) {
      return;
    }

    const { stripe, elements } = this.props;
    const { sickNote } = this.props;

    // Make sure we're sending the proper data structure to the server
    const paymentData = {
      ...sickNote.data,
      formId: sickNote.data?.formId, // Ensure formId is included
      formType: sickNote.data?.formType || 'sick-note'
    };

    // 🔥 CBC TRACKING: Payment started
    const formType = paymentData.formType;
    try {
      const cbcAttribution = localStorage.getItem('cbc_campaign_attribution') || sessionStorage.getItem('cbc_campaign_attribution');
      console.log('🔥 CBC Attribution found:', cbcAttribution);

      if (cbcAttribution) {
        // Track payment initiation
        trackCBCEvent('cbc_payment_started', {
          form_type: formType,
          form_category: formType === 'school-work-form' ? 'school_work' : 'sick_note',
          payment_amount: sickNote.data?.calculatedPrice || 'calculated_on_backend',
          page_count: formType === 'school-work-form' ? sickNote.data?.pageCount : undefined
        });

        console.log(`🔥 CBC PAYMENT STARTED: ${formType}`);

        paymentData.cbcAttribution = JSON.parse(cbcAttribution);
        console.log('🔥 Including CBC attribution in payment request body:', paymentData.cbcAttribution);
        console.log('🔥 Full payment data being sent to backend:', paymentData);
      } else {
        console.log('❌ No CBC attribution found in sessionStorage for payment');
      }
    } catch (error) {
      console.error('Error tracking CBC payment started:', error);
    }

    // console.log("Submitting payment with data:", paymentData);

    if (elements == null) {
      return;
    }

    this.setState({ isSubmitting: true });
    this.props.setToLoading();

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement)
      });

      if (error) {
        this.props.setToLoaded();
        this.setState({ isSubmitting: false });
        console.log('Stripe error:', error);
        setAlert({
          message: error.message,
          icon: 'error'
        });
        return;
      }

      // console.log("Payment method created:", paymentMethod);
      let response = await sickNoteService.charge({
        payment_method_id: paymentMethod.id,
        sickNote: paymentData // Send the properly structured data
      });

      await this.handleServerResponse(response);
    } catch (error) {
      this.props.setToLoaded();
      this.setState({ isSubmitting: false });
      setAlert({
        message: error.message || 'Payment processing error',
        icon: 'error'
      });
    }
  };

  handleDialogClose = () => {
    this.setState({ isDialog: false });
    history.push('/dashboard');
  };

  handleGoBack = () => {
    const { sickNote } = this.props;
    const formType = sickNote.data?.formType || 'sick-note';

    // console.log("Going back from form type:", formType);

    // Navigate back based on form type
    const backPath = formType === 'school-work-form' ? '/school-work-form' : '/sick-note';

    // console.log("Navigating back to:", backPath);
    history.push(backPath);
  };

  render() {
    console.log('🚀 Payment.js - render method called');
    const { stripe, user, sickNote } = this.props;
    const formType = sickNote.data?.formType || 'sick-note';

    // console.log("Rendering CheckoutForm with formType:", formType);
    // console.log("Current sickNote data:", sickNote);

    return (
      <Fragment>
        <Dialog open={this.state.isDialog}>
          <DialogTitle>{formType === 'school-work-form' ? 'Request a Form' : 'Sick Note'} request submitted successfully</DialogTitle>
          <DialogContent>Doctor Budai will get back to you within 24 hours through email. The email we have on file is {user.email}.</DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose}>OK</Button>
          </DialogActions>
        </Dialog>
        <div className="checkout-form mt-2">
          <form onSubmit={this.handleSubmit}>
            <div className="checkout-form__card">
              <CardElement />
            </div>
            <div className="checkout-form__buttons mt-1">
              <button className="checkout-form__buttons__button primary_btn full-width ml-0" type="submit" disabled={!stripe}>
                {this.state.isSubmitting ? 'Processing...' : 'Pay now'}
              </button>
              <button className="mt-1 checkout-form__buttons__button primary_btn bg-secondary full-width ml-0" type="button" onClick={this.handleGoBack}>
                Go back
              </button>
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}
let CheckoutFormConnect = connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);

const InjectedCheckoutForm = () => <ElementsConsumer>{({ stripe, elements }) => <CheckoutFormConnect stripe={stripe} elements={elements} />}</ElementsConsumer>;

const stripePromise = loadStripe(config.stripePublicKey);

const Payment = props => {
  const { config: feeConfig, isUsingDefaults } = useFeeConfig();

  // if user does not have to pay
  // go back to dashboard
  const { sickNote } = props;
  console.log('what is sickNote', sickNote);
  // console.log('sicknote field', sickNote)
  const formType = sickNote.data?.formType || 'sick-note';

  // console.log("Rendering Payment component with formType:", formType);
  // console.log("SickNote data in Payment component:", sickNote.data);

  // Set title based on form type
  const pageTitle = formType === 'school-work-form' ? `${sickNote.data.timeOffIsFor.toUpperCase()} Form Payment` : 'Sick Note Payment';
  const pageSubtitle = formType === 'school-work-form' ? `${sickNote.data.timeOffIsFor}` : 'sick-note/payment';

  // Set amount based on form type and other conditions
  let amount = feeConfig.SICK_NOTE.MSP_ELIGIBLE; // Default for sick note

  if (formType === 'school-work-form') {
    // Use the calculated price from form data if available
    if (sickNote.data?.timeOffIsFor === 'disability') {
      amount = feeConfig.SCHOOL_WORK_FORM.DISABILITY_FLAT_FEE; // Flat fee for disability forms
    } else {
      // Use the calculated price from form data if available
      if (sickNote.data?.calculatedPrice) {
        amount = sickNote.data.calculatedPrice;
      } else {
        // Fallback to dynamic calculation if formData has pageCount
        const pageCount = sickNote.data?.pageCount || 1;
        const firstPagePrice = feeConfig.SCHOOL_WORK_FORM.FIRST_PAGE;
        const additionalPagePrice = feeConfig.SCHOOL_WORK_FORM.ADDITIONAL_PAGE;
        amount = firstPagePrice + (pageCount - 1) * additionalPagePrice;
      }
    }
  } else if (sickNote.data.isPrivate) {
    amount = feeConfig.SICK_NOTE.PRIVATE;
  }

  // console.log("Payment amount:", amount);
  // console.log('page amount', sickNote.data?.pageCount)

  // Get page count from form data for display
  const pageCount = sickNote.data?.pageCount || 1;

  return (
    <>
      <CommonPageHeader title={pageTitle} subtitle={pageSubtitle} />
      <div className="payment">
        <Container>
          {isUsingDefaults && (
            <div className="alert alert-warning">
              <small>Using cached pricing. Current rates may vary.</small>
            </div>
          )}
          <p className="mb-2">Please pay the following fee in order to obtain your {formType === 'school-work-form' ? 'request a form' : 'sick note'}:</p>
          <span className="payment__fee badge badge-pill badge-success">Fee: ${amount}</span>
          <span className="mb-2 ml-3">No refunds</span>

          {formType === 'school-work-form' && sickNote.data?.timeOffIsFor !== 'disability' && pageCount > 1 && (
            <div className="mt-2 mb-2 p-3 border rounded bg-light">
              <p className="mb-0">
                <strong>Price Breakdown:</strong>
              </p>
              <small>
                First page: ${feeConfig.SCHOOL_WORK_FORM.FIRST_PAGE}
                <br />
                {pageCount > 1 && `${pageCount - 1} additional page(s): $${(pageCount - 1) * feeConfig.SCHOOL_WORK_FORM.ADDITIONAL_PAGE}`}
              </small>
            </div>
          )}

          {formType === 'school-work-form' && sickNote.data?.timeOffIsFor === 'disability' && (
            <div className="mt-2 mb-2 p-3 border rounded bg-light">
              <p className="mb-0">
                <strong>Disability Application Fee:</strong>
              </p>
              <small>Flat fee: ${feeConfig.SCHOOL_WORK_FORM.DISABILITY_FLAT_FEE}</small>
            </div>
          )}

          <Elements stripe={stripePromise}>
            <InjectedCheckoutForm />
          </Elements>
        </Container>
      </div>
    </>
  );
};
let temp = connect(mapStateToProps, mapDispatchToProps)(Payment);
export { temp as Payment };
